export interface GuestOfHonor {
  firstName: string;
  lastName: string;
  dateOfBirth: Date;
}
